import { FullEntry } from './types';

const fullContext = require.context('./content', true, /full\.md$/);

export const fulls: FullEntry[] = fullContext.keys().map((path: string) => {
    const raw = fullContext(path);
    const id = path.split('/').slice(-2, -1)[0];

    return {
        id,
        body: raw
    };
});
